module.exports = __webpack_public_path__ + "static/media/404.f28764ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/404.png
// module id = 1063
// module chunks = 0